import { movies } from "@/mocks/movies";
import type { Movie } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

const ranking = (movies.filter((m) => m.rank !== null) as Movie[]).sort(
  (a, b) => (a.rank as number) - (b.rank as number)
);

export default function RankList() {
  return (
    <section id="ranking" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <SectionHeading
          eyebrow="本期排行榜"
          title="九七电影院排行榜 · 口碑与重看价值综合前十"
          desc="榜单按叙事完成度、表演、影像调度与重看价值综合折算成 10 分制排序，同一影片不重复收录。它更像一份找片清单，而不是单一维度的热度榜。"
        />

        <ol className="mt-10 flex flex-col gap-4">
          {ranking.map((movie) => (
            <li
              key={movie.id}
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-300 hover:border-primary-300 md:flex-row md:items-center md:p-4"
            >
              <div className="flex items-center gap-4">
                <span
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md font-heading text-xl font-bold ${
                    (movie.rank as number) <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-800"
                  }`}
                >
                  {movie.rank}
                </span>
                <div className="h-24 w-16 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={movie.img}
                    alt={`《${movie.title}》风格封面`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {movie.title}
                  </h3>
                  <span className="text-xs text-foreground-500">
                    {movie.year} · {movie.region} · {movie.duration}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{movie.summary}</p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {movie.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex items-center justify-between gap-4 md:flex-col md:items-end md:justify-center">
                <div className="text-right">
                  <p className="font-heading text-2xl font-bold text-primary-600">{movie.score}</p>
                  <p className="text-xs text-foreground-500">{movie.votes}人评分</p>
                </div>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                  {movie.category}
                </span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}